import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "site-table"
}
const _hoisted_2 = { class: "column-site" }
const _hoisted_3 = { class: "column-address" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "site-description" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  colspan: 3,
  class: "noDataTd"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  class: "notFoundTd",
  colspan: "3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_RadioBox = _resolveComponent("RadioBox")!
  const _component_CheckBox = _resolveComponent("CheckBox")!

  return (_ctx.sites.length === 0 && _ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, {
        key: 0,
        class: "loader"
      }))
    : (_openBlock(), _createElementBlock("table", _hoisted_1, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _cache[0] || (_cache[0] = _createElementVNode("th", { class: "checkbox" }, null, -1)),
            _createElementVNode("th", _hoisted_2, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('siteSelection.table.site')), 1)
            ]),
            _createElementVNode("th", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('siteSelection.table.address')), 1)
            ])
          ])
        ]),
        (_ctx.sites.length > 0)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sites, (site) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: site.codeSite,
                  class: "pointer",
                  onClick: ($event: any) => (_ctx.toggleSelect(site))
                }, [
                  (!_ctx.isMultiSite)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                        _createVNode(_component_RadioBox, {
                          selected: site.id === _ctx.selectedSite?.id,
                          class: "radio"
                        }, null, 8, ["selected"])
                      ]))
                    : (_openBlock(), _createElementBlock("td", _hoisted_7, [
                        _createVNode(_component_CheckBox, {
                          checked: _ctx.siteSelected(site.id),
                          class: "checkbox",
                          label: ""
                        }, null, 8, ["checked"])
                      ])),
                  _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(site.description), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(_ctx.formatAddress(site)), 1)
                ], 8, _hoisted_5))
              }), 128)),
              (_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_9, [
                    _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t('search.isLoading')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t('search.notFound')), 1)
              ])
            ]))
      ]))
}